import { OneCardPage } from "components/utils/OneCardPage";
import { schemeObjectPageTitle } from "hooks/setPageTitle";
import { useSelectedCompany } from "hooks/useCompany";
import { useSelectedScheme } from "hooks/useScheme";
import type React from "react";
import JobCreateForm from "./JobCreateForm";

const JobCreatePage = (): React.ReactElement => {
  const company_id = useSelectedCompany()?.company_id;
  const scheme_id = useSelectedScheme()?.scheme_id;
  return (
    <>
      {company_id && (
        <OneCardPage
          headerTitle={"Create New Data Job"}
          setPageTitle={schemeObjectPageTitle("Create New Job")}
        >
          <JobCreateForm company_id={company_id} scheme_id={scheme_id} />
        </OneCardPage>
      )}
    </>
  );
};

export default JobCreatePage;
